import { buildActivityKeys } from './utils'

const DEFAULT_ACTIONS = {
  OPEN: 'OPEN',
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  ADD: 'ADD',
  ADD_BULK: 'ADD_BULK',
  CLICK: 'CLICK',
  CLOSE: 'CLOSE',
  MOVE: 'MOVE',
  CANCEL: 'CANCEL',
}

const ACTIVITY_KEYS_TEMPLATE = {
  CUSTOM_LIST: {
    FILTER: DEFAULT_ACTIONS,
    CUSTOM_COLUMN: DEFAULT_ACTIONS,
    ITEM: DEFAULT_ACTIONS,
    CREATE_MODAL: DEFAULT_ACTIONS,
    COLUMNS_VISIBILITY_MODAL: {
      COLUMN_TOGGLE: DEFAULT_ACTIONS,
    },
    NOTE: { ...DEFAULT_ACTIONS, CLEAR: 'CLEAR' },
    STATUS: { ...DEFAULT_ACTIONS, SELECT: 'SELECT' },
    PRIORITY_COLUMN: DEFAULT_ACTIONS,
  },
  LOGOUT: DEFAULT_ACTIONS,
  SETTINGS: DEFAULT_ACTIONS,
  SEARCH: {
    SORT: DEFAULT_ACTIONS,
    EVENT_FILTER: DEFAULT_ACTIONS,
  },
  ATTENDEES_MODAL: {
    CONTACT_BUTTON: DEFAULT_ACTIONS,
  },
  CONTACT_MESSAGE_INBOX: {
    INBOX: DEFAULT_ACTIONS,
    SORT: DEFAULT_ACTIONS,
    MENU: DEFAULT_ACTIONS,
    COLLAPSE: DEFAULT_ACTIONS,
    CHAT: DEFAULT_ACTIONS,
  },
  ALERTS: {
    DELETE_MODAL: DEFAULT_ACTIONS,
    EMAIL: DEFAULT_ACTIONS,
  },
} as const

export const EVENT_ACTIVITY_KEYS = buildActivityKeys(ACTIVITY_KEYS_TEMPLATE)
